module.exports = {
  "name": "jasfgg",
  "client": "Mobile spot",
  "description": "Mobile app for test",
  "validLangs": ["fr"],
  "native": {
    "author": "Mobile-Spot",
    "backgroundColor": "0xffffff",
    "iosBuildTarget": "11.0",
    "androidFadeSplashScreenDuration": 750,
    "androidTargetSdkVersion": 33,
    "androidCompileSdkVersion": 33,
    "androidSigning": {
      "keyAlias": "mobilespot-jasfgg",
      "keyStorePassword": "jee1Uu0Hieloh7bi"
    },
    "app": "app-react",
    "name": {
      "default": "JASFGG 2023_D"
    },
    "id": "com.mobilespot.jasfgg.dev",
    "appleTeamId": "2BAP3P29V2",
    "playStoreUrl": ""
  },
  "undeliveredFolders": ["source", "exports"],
  "crypto": false,
  "web": {
    "url": "jasfgg2023.ms-dev.mobile-spot.com"
  },
  "version": {
    "mainVersion": "3.0.0",
    "buildVersion": {
      "iOS": "41",
      "android": "40",
      "web": "62"
    }
  },
  "relatedRepos": [{
    "src": "git@bitbucket.org:mobilespotdev/cordova.git",
    "branch": "inte/jasfgg/main",
    "postCommands": ["cd cordova && npm install"]
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo.git",
    "branch": "inte/jasfgg/main",
    "postCommands": ["cd mobigeo && npm install"]
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo-customs-master.git",
    "branch": "inte/jasfgg/main",
    "dest": "mobigeo/mobigeo-customs"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/app-react.git",
    "branch": "inte/jasfgg/main"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/data-master.git",
    "branch": "inte/jasfgg/main",
    "dest": "app-react/app-customs",
    "postCommands": ["cd app-react && yarn", "cd app-react && npm run set-env dev", "cd app-react && npm run download-assets", "cd app-react && npm run download-data-files", "cd app-react && npm run update-mobigeo"]
  }]
};